// Action creators
// http://localhost:60452/api/OnCallSchedule/UpsertCurrentSchedule
// http://localhost:60452/api/OnCallSchedule/List
// http://localhost:60452/api/OnCallSchedule/GetMostRecentSchedule 
// http://localhost:60452/api/OnCallSchedule/GetAllRecentSchedules

var getScheduleFetch = () => {
  return function (dispatch) {
    return fetch('api/OnCallSchedule/GetAllRecentSchedules')
      .then(results => {
        return results.json();
      }).then(json => {
        console.log("[schedule_actions.js] getScheduleFetch payload: ", json);
        dispatch({ type: 'LOAD_SCHEDULE', payload: json }); 
      });
    // add error handler
  };
}

var toggleUser = (userId, company) => {
  return function (dispatch) {
    dispatch({ type: "TOGGLE_EMAIL_LIST_USER", payload: { 'userId': userId, 'company': company } });
  };
}


// what data needs to be posted? {id: "", scheduleId: "", beginTime: "", endTime: "", prime: "", secondary: "", tertiary: ""}

var updateSchedule = (company, schedule) => {
  return function (dispatch) {
    console.log("UPDATE SCHEDULE CALLED", company);
    console.log("UPDATE SCHEDULE CALLED", schedule);
    return fetch("api/OnCallSchedule/UpsertCurrentSchedule", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ 'Company': company, 'LineItems': schedule['onCallLineItems']})
    })
  }
}

var sendEmail = (company, schedule) => {
  return function (dispatch) {
    var l = [];
    for (var i = 0; i < schedule['checkedUserIds'].length; i++) {
      var onCallLineItem = schedule['checkedUserIds'][i];
      l.push({ 'EmailRecipient': onCallLineItem });
    }
    console.log("SEND EMAIL CALLED", company);
    console.log("SEND EMAIL CALLED", schedule);
    console.log(JSON.stringify({ 'Company': company, 'LineItems': l, 'ScheduleId': schedule.id}));
    return fetch("api/OnCallEmailList/SendEmail", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ 'Company': company, 'LineItems': l, 'ScheduleId': schedule.id })
    })
  }
}

export default { 'LOAD_SCHEDULE': getScheduleFetch, 'SEND_EMAIL': sendEmail, 'TOGGLE_USER': toggleUser, 'UPDATE_SCHEDULE': updateSchedule };


// WEBPACK FOOTER //
// ./src/actions/schedule_actions.js